<script lang="ts">
	import { doesUrlContainImage } from "../../../../core/utils/doesUrlContainImage.js";
	import LabelledInput from "./LabelledInput.svelte";

	export let id: string;
	export let value: string | undefined = undefined;
	export let hiddenInput: HTMLInputElement | null = null;
	export let disabled = false;
	export let showValid = false;
	export let showClear = false;

	let errorMessage: string | undefined;
	let isValid = Boolean(value);

	async function checkUrl(input: HTMLInputElement): Promise<boolean> {
		const { value } = input;
		isValid = false;
		if (!value) {
			errorMessage = undefined;
			return false;
		}
		if (!URL.canParse(value)) {
			errorMessage = "Odkaz musí být platná URL adresa začínající na https://.";
			return false;
		}
		input.setCustomValidity("Probíhá kontrola odkazu…");
		const isImage = await doesUrlContainImage(value);
		input.setCustomValidity("");
		if (isImage) {
			isValid = true;
			errorMessage = undefined;
			return true;
		}
		errorMessage = "Na odkazu se nenachází obrázek. Vložte jiný odkaz.";
		return false;
	}

	function updateValue(value: string): void {
		if (!hiddenInput) {
			return;
		}

		hiddenInput.value = value;
		hiddenInput.dispatchEvent(new Event("input", { bubbles: true }));
		hiddenInput.dispatchEvent(new Event("change", { bubbles: true }));
	}

	async function onInputChange({ target }: Event): Promise<void> {
		const input = target as HTMLInputElement;

		const isValid = await checkUrl(input);
		updateValue(isValid ? input.value : "");
	}

	async function onValueUpdate(value: string): Promise<void> {
		if (!hiddenInput) {
			return;
		}

		const isValid = await checkUrl(hiddenInput);
		updateValue(isValid ? value : "");
	}

	$: {
		if (value) {
			void onValueUpdate(value);
		} else {
			isValid = false;
			errorMessage = undefined;
		}
	}
</script>

<LabelledInput
	id="{id}-check"
	type="url"
	showErrorMessage={Boolean(errorMessage)}
	{errorMessage}
	showValid={showValid && isValid}
	clearable={showClear}
	fullWidth
	{value}
	{disabled}
	placeholder="Vložte odkaz"
	on:change={onInputChange}
	withoutLabel
/>

<input bind:this={hiddenInput} type="hidden" name={id} on:change />
